import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ILogsService, ResponseData, ILogs } from './logs-service.interface';
import { ENVIRONMENT_SERVICE_TOKEN, IEnvironmentService } from '../environment/environment-service.interface';

export const LOGS_SERVICE_TOKEN = new InjectionToken<ILogsService>('ILogsService');

@Injectable()
export class LogsService implements ILogsService {
  private url: string;

  constructor(
    @Inject(ENVIRONMENT_SERVICE_TOKEN) private environmentService: IEnvironmentService,
    private http: HttpClient
  ) {
    this.url = this.environmentService.apiUrl;
  }

  logs(): Observable<ILogs[]> {
    return this.http.get(`${this.url}/account/auth-logs`, { params: { limit: 10, page: 1 } }).pipe(
      map((response: ResponseData) => {
        return response.data;
      })
    );
  }
}
